import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "semantic-ui-react";

export const Page403 = () => {
  const history = useHistory();
  return (
    <div className='tw-flex tw-min-h-[100vh] tw-flex-col tw-items-center tw-justify-center'>
      <div className='tw-flex tw-flex-col tw-items-center'>
        <h1 className='tw-mb-2 tw-mt-[-48px] tw-text-[40px] tw-font-normal tw-opacity-90'>Forbidden</h1>
        <p className='text-[16px] tw-mb-6'>You do not have permission to access this resource</p>
        <Button primary content='Go Back' onClick={() => history.goBack()} />
      </div>
    </div>
  );
};

export default Page403;
